// Tennis Diary — service worker registration helper.
// Notifies the app via `sw-update-available` when a new SW is waiting, so
// the PwaUxLayer can prompt the user to refresh (logic lives in App.js).

const isLocalhost = typeof window !== 'undefined' && Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname)
);

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Allow forcing-off via env (e.g., for e2e tests)
  if (process.env.REACT_APP_DISABLE_SW === 'true') {
    unregisterAll();
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker
      .register(swUrl, { scope: '/' })
      .then((registration) => {
        if (isLocalhost) {
          // Helpful console hint in dev
          // eslint-disable-next-line no-console
          console.log('[PWA] Service worker registered (localhost).');
        }
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              window.__tdSwWaiting = registration.waiting || installing;
              window.dispatchEvent(new Event('sw-update-available'));
            }
          });
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[PWA] Service worker registration failed:', err && err.message);
      });

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      // Will be reloaded explicitly by user via the PwaUxLayer button.
    });
  });
}

export function unregisterAll() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
}
